module.exports = () => ({
  contact: '',
  dateOff: 0,
  dateOn: 0,
  dateOffWho: '',
  notes: '',
  owner: '',
  reason: '',
  stuID: '',
  key: ''
})



// WEBPACK FOOTER //
// ./src/store/newRecord.js